import { generateId } from '@freelancer/datastore/testing/helpers';
import type { SupportSessionNote } from './support-session-notes.model';

export interface GenerateSupportSessionNoteOptions {
  readonly id?: number;
  readonly supportSessionId: number;
  readonly supportAgentId: number;
  readonly note?: string;
  readonly createdAt?: number; // Unix timestamp in milliseconds
}

export function generateSupportSessionNoteObject({
  id = generateId(),
  supportSessionId,
  supportAgentId,
  note = 'Test support session note',
  createdAt = Date.now(), // Unix timestamp in milliseconds
}: GenerateSupportSessionNoteOptions): SupportSessionNote {
  return {
    id,
    supportSessionId,
    supportAgentId,
    note,
    createdAt,
  };
}
